export default function usePlatformSwitcher() {
  // Use the system store to get platform information
  const systemStore = useSystemStore()
  const { t } = useI18n()
  const route = useRoute()

  // Computed properties
  const currentPlatform = computed(() => systemStore.platform)

  const flagSrc = computed(() => {
    const currentPlatformFlag = currentPlatform.value === 'CH' ? 'CH' : 'EU'
    return `/img/flags/${currentPlatformFlag}-round.svg`
  })

  const switchToUrl = computed(() => {
    const toTld = currentPlatform.value === 'CH' ? 'de' : 'com'

    // If the sign up page is opened through the Cello referral link,
    // keep the Cello query params after redirecting so that the referral code can still be applied
    if (route.query.ucc) {
      const queryParams = new URLSearchParams(
        Object.entries(route.query).map(([key, value]) => [key, String(value)])
      ).toString()
      return `https://my.skribble.${toTld}/business/signup?${queryParams}`
    }
    // For regular users redirect to the respective platform
    return `https://my.skribble.${toTld}${route.fullPath}`
  })

  const switchToTextLogin = computed(() => {
    return currentPlatform.value === 'CH'
      ? t('platform_switch.switch_to.login.ch')
      : t('platform_switch.switch_to.login.de')
  })

  const switchToTextSignup = computed(() => {
    return currentPlatform.value === 'CH'
      ? t('platform_switch.switch_to.signup.ch')
      : t('platform_switch.switch_to.signup.de')
  })

  const currentCountry = computed(() => {
    return currentPlatform.value === 'CH' ? t('global.ch') : t('global.eu')
  })

  return {
    currentCountry,
    flagSrc,
    switchToUrl,
    switchToTextLogin,
    switchToTextSignup,
    currentPlatform,
  }
}
